/**
 * プレースホルダーテキスト（URL が未入力の場合に表示）
 */
export const PLACEHOLDER_TEXT = 'URLを入力するとプレビューが表示されます'

/**
 * ページ番号を有効な範囲（1〜total）にクランプする。
 * total が 0 以下の場合は 1 を返す（呼び出し側で空配列判定を行う前提の安全な既定値）。
 * page / total が非有限値（NaN / Infinity）の場合も 1 にフォールバックする。
 */
export const clampPage = (page: number, total: number): number => {
  if (!Number.isFinite(total) || total <= 0) {
    return 1
  }

  if (!Number.isFinite(page) || page < 1) {
    return 1
  }

  if (page > total) {
    return total
  }

  return page
}

/**
 * postIds から page（1始まり）に対応する post_id を選択する。
 * postIds が空配列の場合は null を返す。
 * page が範囲外の場合はクランプ後の要素を返す。
 * postIds に含まれる null もページとしてカウントされる。
 */
export const selectPostId = (postIds: (string | null)[], page: number): string | null => {
  if (postIds.length === 0) {
    return null
  }

  const clamped = clampPage(page, postIds.length)

  return postIds[clamped - 1] ?? null
}
